import { useState } from "react";

const BarSwitches = ({ relevantRef, options, setChosenType = null }) => {
  const [selected, setSelected] = useState(null);
  const [smsConsentChecked,setSmsConsentChecked] = useState()


  const handleStatusChange = (e) => {
    const status = e.target.value;
    relevantRef.current = status;
    // setChosenType(status);
    setSelected(status);
  };

  return (
    <>
    <div className="alert-switch-container">
      {options.map((option, index) => (
        <label
          key={option.value}
          className={`alert-switch-option ${selected === option.value ? "selected" : ""}`}
        >
          <input
            type="radio"
            name="alertSwitch"
            value={option.value}
            checked={selected === option.value}
            onChange={handleStatusChange}
          />
          {option.label}
        </label>
      ))}
    </div>
    <>
  {selected === "text" && (
    <div
      className="input-group"
      style={{
        marginTop: 12,
        padding: "10px 12px",
        backgroundColor: "#f9f9f9",
        border: "1px solid #ccc",
        borderRadius: "8px",
      }}
    >
      <label
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "10px",
          fontSize: "14px",
          lineHeight: "1.4",
          color: "#333",
        }}
      >
        <input
          type="checkbox"
          checked={smsConsentChecked}
          onChange={(e) => setSmsConsentChecked(e.target.checked)}
          style={{
            marginTop: "3px",
            transform: "scale(1.2)",
            accentColor: "#4caf50",
            cursor: "pointer",
          }}
        />
        <span>
          I consent to opt-in and receive <strong>SMS text alerts</strong> from Indian Park Association. Message and data rates may apply. Reply <strong>STOP</strong> to unsubscribe.
        </span>
      </label>
    </div>
  )}
</>

    </>
  );
};

export default BarSwitches;
